import Api from "./Api";
import axios from "axios";
import { BASEURL } from "@/config/index";
// let AUTH_KEY = window.localStorage.getItem("AUTH_KEY")
// const configHeaders = {
//   headers: {
//     'content-type': 'application/json',
//     'Authorization': AUTH_KEY
//   }
// }

export default {
  AddUser(payload, configHeaders) {
    return Api().post(`/setup-add-users`, payload, configHeaders);
  },
  SetupStatus() {
    return Api().get(`/setup/status`);
  },
  GetOrgName() {
    return Api().get(`/setup/org_name`);
  },
  VerfiyAuthKey(payload) {
    return Api().post(`/setup/verify_auth_key`, payload);
  },
  CheckToken(payload) {
    return Api().post(`/setup/check_token`, payload);
  },
  // setup/send_email
  SendMail(payload) {
    return Api().post(`/setup/send_email`, payload);
  },
  AddOrg(payload) {
    return Api().post(
      `/setup/add-organization`,
      payload,
      payload.configHeaders
    );
  },
  AddCinemaConfig(payload, configHeaders) {
    return Api().post(`/setup/cinema-config`, payload, configHeaders);
  },
  UpdateUpdateCinemaSetting(payload) {
    return Api().put(`/setup/cinema-config/${payload.cinema_id}`, payload);
  },
  AddCinema(payload) {
    return Api().post(`/setup/add-cinema`, payload, payload.configHeaders);
  },
  AddFinance(payload) {
    return Api().post(`/setup/add-finance`, payload);
  },
  AddScreen(payload) {
    return Api().post(`/setup/add-screen`, payload);
  },
  addScreenLayout(payload) {
    return Api().post(`/setup/add-screenlayout1`, payload);
  },
  getChargeType() {
    return Api().get(`/setup/getchargetype`);
  },
  loginCinemaUser(payload) {
    return Api().post("/setup/logincinemauser", payload);
  },
  addCinemaDB(payload) {
    return Api().post("/setup/add-cinema-db", payload);
  },
  addConcessionLevel(payload) {
    return Api().post("/setup/add-concession-level", payload);
  },
  addCounterLevels(payload) {
    return Api().post("/setup/add-counter-levels", payload);
  },
  getCounterLevels(payload) {
    return Api().post("/setup/get-counter-levels", payload);
  },
  addHardwareSettings(payload) {
    return Api().post("/setup/add-hardware-settings", payload);
  },
  updateStatus() {
    return Api().get("/setup/update-status");
  }
};



// WEBPACK FOOTER //
// ./src/services/SetupService.js